import { ContextManager, ContextInstance } from "../contextManager/ContextManager";
import { reportError } from "../error/ThrowError/reportError";
import ErrorReporter from "./ErrorReporter";
import { FlexSdkError } from "~/modules/error";
import { SimpleSubscription } from "~/modules/reporter/CustomObservable/SimpleSubscription";
import { SimpleObserver } from "~/modules/reporter/CustomObservable/SimpleObserver";

const subscriptions: Array<SimpleSubscription> = [];




export const initErrorSubscriptions = (ctx: ContextManager) => {
    const myObserver: SimpleObserver<FlexSdkError> = {
        next: (value: FlexSdkError) => {
            reportError(ctx)(value);
        }
    };
    const telemetryErrorStream = ctx.retrieveInstanceOf(
        ContextInstance.ErrorReporter,
        ErrorReporter
    ).telemetryErrorStream;

    const result = telemetryErrorStream.subscribe(myObserver);

    subscriptions.push(result);
};




export const clearErrorSubscriptions = (): void => {
    subscriptions.forEach((sub) => sub.unsubscribe());
    subscriptions.splice(0);
};




export const getSubscriptions = (): Array<SimpleSubscription> => subscriptions.concat();
